import * as React from 'react'
import { createIcon } from './createIcon'
import { IconOptions } from './icon-options'

function IconContent({ color }: IconOptions) {
  return (
    <React.Fragment>
      <rect x='3' y='5' width='8' height='4' rx='1' fill={color} />
      <rect x='3' y='12' width='8' height='1' fill={color} />
      <rect x='3' y='15' width='8' height='1' fill={color} />
      <rect x='13' y='5' width='8' height='4' rx='1' fill={color} />
      <rect x='13' y='12' width='8' height='1' fill={color} />
      <rect x='13' y='15' width='8' height='1' fill={color} />
      <rect x='3' y='18' width='8' height='1' fill={color} />
      <rect x='13' y='18' width='8' height='1' fill={color} />
    </React.Fragment>
  )
}

export const CompsTableIcon = createIcon(IconContent)
